import Common from 'js/_core/Common'

import ViewController from 'js/app/controllers/ViewController'
import CareerFaqAccordion from 'js/modules/projects/ui/CareerFaqAccordion'
import CareerArticleLoadMore from 'js/modules/projects/ui/CareerArticleLoadMore'
import { gsap } from 'gsap'

export default class CareerHomeViewController extends ViewController {
  constructor(content) {
    super(content)
    if (this.debug) {
      this.pageName = '[CareerHome]'
    }

    // ページ別のコンテンツ(html)はここからアクセスできます
    this.$content = content
    this.careerFaqAccordion = new CareerFaqAccordion({
      $contentRoot: this.$content,
    })
    this.careerArticleLoadMore = new CareerArticleLoadMore({
      $contentRoot: this.$content,
    })
  }

  async willLoad() {
    await super.willLoad()
  }

  async didLoad() {
    await super.didLoad()
  }

  async beforeEnter() {
    await super.beforeEnter()
    this.careerFaqAccordion.init()
    this.careerArticleLoadMore.init()
  }

  async enter() {
    this.addHandlers()
    await super.enter()
    this._addObservers()
    this._setLayout()
    if (Common.webgl) {
      gsap.delayedCall(0.2, () => {
        Common.webgl.fvAnimation({
          pageId: 'CareerHome',
        })
      })
    }
  }

  async afterEnter() {
    await super.afterEnter()
  }

  async beforeLeave() {
    await super.beforeLeave()
    this.careerArticleLoadMore.destroy()
    this._removeObservers()
    this.removeHandlers()
  }

  async leave() {
    await super.leave()
  }

  async afterLeave() {
    await super.afterLeave()
  }

  _set$() {
    super._set$()
  }

  addHandlers() {
    super.addHandlers()
    if (Common.resize) {
      Common.resize.addHandler(() => {
        this.onResize()
      }, 'CareerHomeControllerResize')
    }
  }

  removeHandlers() {
    super.removeHandlers()
    if (Common.resize) {
      Common.resize.removeHandler('CareerHomeControllerResize')
    }
  }

  _addObservers() {}

  _removeObservers() {}

  _setLayout() {
    if (!Common.detection.isMobileLayout) {
    }
  }

  onResize() {
    super.onResize()
    this._setLayout()
  }
}